import { Injectable } from '@angular/core';

import {
  HttpClient,
  HttpParams
} from '@angular/common/http';

import {
  Observable
} from 'rxjs';

import {
  environment
} from '../../environments/environment';


export interface Tarifas {
  [dia: string]: {
    [quantidadeHospedes: number]: number;
  };
}

export interface Quarto {
  id: number;
  nome: string;
  descricao: string;
  capacidade: number;
  tarifas: Tarifas;
  tarifasData: {
    [data: string]: {
      [quantidadeHospedes: number]: number;
    };
  };
  valorCrianca: number;
  valorAnimal: number;
  status: 'DISPONIVEL' | 'INDISPONIVEL';
}


export interface QuartoRequest {
  nome: string;
  descricao: string;
  capacidade: number;
  tarifas: Tarifas;
  valorCrianca: number;
  valorAnimal: number;
}


@Injectable({
  providedIn: 'root'
})
export class QuartoService {

  private readonly apiUrl =
    `${environment.apiUrl}/quartos`;


  constructor(
    private http: HttpClient
  ) {}

  listar(): Observable<Quarto[]> {

    return this.http.get<Quarto[]>(
      this.apiUrl
    );

  }

  buscarPorId(
    id: number
  ): Observable<Quarto> {

    return this.http.get<Quarto>(
      `${this.apiUrl}/${id}`
    );

  }

  criar(
    quarto: QuartoRequest
  ): Observable<Quarto> {

    return this.http.post<Quarto>(
      this.apiUrl,
      quarto
    );

  }

  atualizar(
    id: number,
    quarto: QuartoRequest
  ): Observable<Quarto> {

    return this.http.put<Quarto>(
      `${this.apiUrl}/${id}`,
      quarto
    );

  }

  alterarStatus(
    id: number,
    status: 'DISPONIVEL' | 'INDISPONIVEL'
  ): Observable<void> {

    const params =
      new HttpParams()
        .set('status', status);

    return this.http.patch<void>(
      `${this.apiUrl}/${id}/status`,
      null,
      {
        params
      }
    );

  }

  excluir(
    id: number
  ): Observable<void> {

    return this.http.delete<void>(
      `${this.apiUrl}/${id}`
    );

  }

}
